<template>
  <div>
    <v-alert
      type="warning"
      class="font-weight-medium mb-6"
      v-if="!isQuizCompleted"
    >
      民眾尚未完成數位問卷
    </v-alert>
    <d-input
      class="mt-4 text-h6"
      v-model.number="payload.第一次收縮壓"
      label="收縮壓"
      max="300"
      @keyup.enter.native="submit"
      :option="{ suffix: 'mmHg', integer: true }"
    ></d-input>
    <d-input
      class="mt-4 text-h6"
      v-model.number="payload.第一次舒張壓"
      label="舒張壓"
      max="300"
      @keyup.enter.native="submit"
      :option="{ suffix: 'mmHg', integer: true }"
    ></d-input>
    <d-input
      class="mt-4 text-h6"
      v-model.number="payload.脈搏"
      label="脈搏"
      max="200"
      @keyup.enter.native="submit"
      :option="{ suffix: '次/分', integer: true }"
    ></d-input>

    <v-btn block x-large class="mt-4 text-h6" color="success" @click="submit"
      >送出</v-btn
    >
    <v-btn block x-large class="mt-8 text-h6" color="error" @click="back"
      >取消</v-btn
    >
  </div>
</template>

<script>
import station from "@/mixins/station";
export default {
  mixins: [station],
  data: () => ({
    payload: {
      第一次收縮壓: null,
      第一次舒張壓: null,
      脈搏: null,
    },
  }),
};
</script>

<style lang="scss" scoped></style>
